import { configureStore, Tuple } from '@reduxjs/toolkit';
import { userReducer } from './slices/masters/user/userApiSlice';
import { persistStore, persistReducer } from 'redux-persist';
import { createLogger } from 'redux-logger';
import { thunk } from 'redux-thunk';
import {
  persistRolesConfig,
  persistStaffDashboardConfig,
  persistUserConfig,
} from './persist-config';
import { rolesReducer } from './slices/masters/roles/roleSlice';
import { userListReducer } from './slices/masters/user/userListSlice';
import { globalApiService } from './apis/globalApiSlice';
import { commonReducers } from './slices/commonSlice';
import { carrierReducers } from './slices/main/carrier/carrier-slice';
import { staffDReducers } from './slices/main/dashboard/staffDashboardMyTaskSlice';

const isClient = typeof window !== 'undefined';
const isDev = import.meta.env.NODE_ENV === 'development';

const logger = createLogger({
  predicate: () => {
    // run logger only if in dev environment and in client
    return false;
    return isDev && isClient;
  },
});

export const store = configureStore({
  reducer: {
    //apis
    [globalApiService.reducerPath]: globalApiService.reducer,

    //common
    common: commonReducers,

    //main
    carriers: carrierReducers,
    staffDashboard: persistReducer(persistStaffDashboardConfig, staffDReducers),

    // masters
    user: persistReducer(persistUserConfig, userReducer),
    userList: userListReducer,
    roles: persistReducer(persistRolesConfig, rolesReducer),
  },
  middleware: () => new Tuple(thunk, logger, globalApiService.middleware),
});

export const persistor = persistStore(store);

// Infer the type of makeStore
export type AppStore = typeof store;
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<AppStore['getState']>;
export type AppDispatch = AppStore['dispatch'];
